// extracted by mini-css-extract-plugin
export default {"input":"styles_input__2saVh","label":"styles_label__T8xes"};